<template>
  <multiselect
    :multiple="true"
    :options="options"
    :searchable="true"
    :internal-search="false"
    :option-height="104"
    :loading="isSearching"
    :options-limit="50"
    :value="symptoms"
    track-by="id"
    label="title"
    placeholder="Επιλέξτε σύμπτωμα με χρήση τίτλου..."
    selected-label="Επιλεγμένο"
    select-label="Πατήστε enter για επιλογή"
    deselect-label="Πατήστε enter για απο-επιλογή"
    class="multiple"
    data-vv-value-path="value"
    data-vv-name="symptom"
    @search-change="searchSymptoms"
    @select="selectSymptom"
    @remove="removeSymptom"
  >
    <template v-slot:option="props" class="option">
      <div class="option__desc">
        <span class="option__title">{{ props.option.title }}</span>
      </div>
    </template>
    <template v-slot:noResult>
      Δε βρέθηκαν αποτελέσματα. Προσπαθήστε ξανά!!
    </template>
  </multiselect>
</template>

<script>
import Multiselect from 'vue-multiselect';
import _debounce from 'lodash/debounce';
import request from '@/utils/request';
import Photo from '@/views/components/Photo';

export default {
  inject: ['$validator'],
  components: {
    Multiselect,
    Photo,
  },
  props: {
    symptoms: Array,
  },
  data() {
    return {
      options: [],
      isSearching: false,
    };
  },
  methods: {
    // eslint-disable-next-line func-names
    searchSymptoms: _debounce(async function(searchQuery) {
      if (searchQuery.length) {
        this.isSearching = true;
        const { data } = await request.get('/symptoms-search', {
          params: {
            term: searchQuery,
          },
        });
        this.isSearching = false;

        this.options = data.symptoms;
      }
    }, 300),
    selectSymptom(selectedOption) {
      this.$emit('selectSymptom', selectedOption);
    },
    removeSymptom(selectedOption) {
      this.$emit('removeSymptom', selectedOption);
    },
  },
};
</script>

<style scoped lang="scss">
.multiselect {
  margin: 0 auto;
}
</style>
